var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "clearfix" },
    [
      _c(
        "div",
        {
          ref: "previewSubmissionModal",
          staticClass: "reveal preview-submission-modal",
          attrs: { id: "previewSubmissionModal", "data-reveal": "" },
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tender-confirm clearfix" },
            [
              _c("div", { staticClass: "submission-email-subject" }, [
                _c("label", [_vm._v(_vm._s(_vm.$t("eCircular.subject")))]),
                _vm._v(" "),
                _vm.currentTenantSubmission
                  ? _c("div", [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm.$t(
                              "tenantProjects.tenantViewComments.batchNumberComments",
                              [Number(_vm.currentTenantSubmission.order) + 1]
                            ) +
                              " - " +
                              _vm.currentTenantProject.projectName
                          ) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.canSend ? _c("EmailEditFields") : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "comments-preview-body-warpper" },
                [
                  _c("CommentsPreviewBody", {
                    attrs: {
                      isBatchesView: false,
                      activeBatch: _vm.currentTenantSubmission,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.modalInitiated
                ? _c("TenantSubmissionDocuments", {
                    attrs: {
                      files: _vm.files,
                      sourceId: (_vm.currentTenantSubmission || {}).id || "",
                      canEdit: false,
                    },
                    on: {
                      "update:files": function ($event) {
                        _vm.files = $event
                      },
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("CommentHistory", {
                attrs: { submission: _vm.currentTenantSubmission },
              }),
              _vm._v(" "),
              _vm.canSend
                ? _c("div", { staticClass: "row align-right nav_btn" }, [
                    _c(
                      "button",
                      {
                        directives: [
                          { name: "hkldreset", rawName: "v-hkldreset" },
                        ],
                        staticClass: "btn btn--darkblue",
                        attrs: {
                          id: "confirm_no",
                          type: "button",
                          disabled: !_vm.hasPendingSubmission,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.saveReceivers()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.save")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        directives: [
                          { name: "hkldreset", rawName: "v-hkldreset" },
                        ],
                        staticClass: "btn btn--orange",
                        attrs: {
                          id: "confirm_ok",
                          type: "button",
                          disabled: _vm.disableSend || _vm.hasChangedToFU,
                        },
                        on: {
                          click: function ($event) {
                            return _vm.openSubmitConfirm()
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("action.send")))]
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isDesignCommentFulfilled || !_vm.hasPendingSubmission
                ? _c("div", { staticClass: "error-msg" }, [
                    _vm._v(
                      "\n        " + _vm._s(_vm.completeErrMsg) + "\n      "
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.isMandatoryFieldsValid && _vm.isReinstatement
                ? _c("div", { staticClass: "error-msg" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("tenantProjects.mandatoryFieldsMissed")) +
                        "\n      "
                    ),
                  ])
                : _vm._e(),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("ActionConfirmModal", {
        ref: "submitConfirmModal",
        attrs: {
          modalId: _vm.submissionSendConfId,
          confirmTitle: _vm.confirmTitle,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "close-button",
        attrs: {
          "data-close": "",
          "aria-label": "Close modal",
          type: "button",
        },
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }